const ROMAJI = "a i u e o|ka ki ku ke ko|sa shi su se so|ta chi tsu te to|na ni nu ne no|ha hi fu he ho|ma mi mu me mo|ya yu yo|ra ri ru re ro|wa wo|n";
const HIRAGANA = "あいうえお|かきくけこ|さしすせそ|たちつてと|なにぬねの|はひふへほ|まみむめも|やゆよ|らりるれろ|わを|ん";
const KATAKANA = "アイウエオ|カキクケコ|サシスセソ|タチツテト|ナニヌネノ|ハヒフヘホ|マミムメモ|ヤユヨ|ラリルレロ|ワヲ|ン";

const build = (chars) => {
  const r = ROMAJI.split("|").map((row) => row.split(" "));
  return chars.split("|").map((row, i) => [...row].map((char, j) => ({ char, romaji: r[i][j] })));
};

export const KANA = { hiragana: build(HIRAGANA), katakana: build(KATAKANA) };
